<template>
	<div class="design">
		<section class="design__header">
			<el-link @click.stop="handleBack" icon="el-icon-back" type="text" :underline="false">返回</el-link>
			<el-divider direction="vertical"></el-divider>
			<span class="title">渠道管理</span>
			<div class="group">
				<el-button @click.stop="handleCreate" type="primary" size="mini">新增渠道</el-button>
			</div>
		</section>
		<section class="design__container">
			<div class="basis-page-cls">
				<section class="basis-cls_table">
					<div class="table">
						<table-pagination
							pagination
							:data="list"
							:column="column"
							:total="total"
							:page.sync="listQuery.pageNumber"
							:limit.sync="listQuery.pageSize"
							@pagination="getList" />
					</div>
				</section>
			</div>
		</section>

		<el-drawer 
            :title="dialog_status == 'create' ? '新增渠道' : '修改渠道'" 
            :visible.sync="dialog_visible_touch_in"
            :wrapperClosable="false"
			size="600px"
            direction="rtl">
            <el-form labelPosition="right" autoComplete="on" labelWidth="120px" :model="channelForm" ref="channelForm">
                <el-form-item prop="channelName" label="渠道名称：" :rules="[{required: true, trigger: 'blur', message: '请输入渠道名称'}]">
                    <el-input v-model="channelForm.channelName" placeholder="请输入渠道名称" style="width:450px;" maxlength="30" show-word-limit clearable></el-input>
                </el-form-item>
				<el-form-item prop="channelIdentify" label="渠道标识：" :rules="[{required: true, trigger: 'blur', validator: validateStr}]">
                    <el-input v-model="channelForm.channelIdentify" placeholder="请输入渠道标识" style="width:450px;" maxlength="30" show-word-limit clearable></el-input>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item style="float: right;padding-right: 30px;">
                    <el-button @click="dialog_visible_touch_in = false">取 消</el-button>
                    <el-button @click.stop="create" :loading="loading" v-if="dialog_status == 'create'" type="primary">提 交</el-button>
                    <el-button @click.stop="update" :loading="loading" v-if="dialog_status == 'update'" type="primary">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { tagviewsMixins } from "utils/mixins";
import { validateStr } from "utils/validator";
export default {
	name: "BrandChannel",
	mixins: [tagviewsMixins],
	data() {
		return {
			validateStr,
			column: [
				{ label: '渠道名称', prop: 'channelName', minWidth: 120 },
				{ label: '渠道标识', prop: 'channelIdentify', minWidth: 120 },
				{ 
					label: '状态', 
					minWidth: 100, 
					render: (h, scope) => {
						return (
							<el-switch
								class="switch"
								onChange={() => this.switchStatus(scope.row, scope.$index)}
								v-model={scope.row.status}
								active-value='enable'
								inactive-value='disable'
								active-color='#13ce66'>
							</el-switch>
						)
					}
				},
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 100,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<div>
								<el-button onClick={() => this.handleUpdate(scope.row)} disabled={scope.row.isFixed == 1} type="text">修改</el-button>
								<el-button onClick={() => this.handleDelete(scope.row)} disabled={scope.row.isFixed == 1} type="text">删除</el-button>
							</div>
						)
                    }
                }
            ],
			listQuery: {
				brandIdentify: '',
				pageNumber: 1,
				pageSize: 10
			},
			list: [],
			total: 0,
			loading: false,
			dialog_visible_touch_in: false,
			dialog_status: 'create',
			channelForm: {
				brandIdentify: '',
				channelIdentify: '',
				channelName: ''
			},
			brandIdentify: ''
		}
	},
	computed: {
		...mapState({
			visitedViews: state => state.tagsView.visitedViews
		})
	},
	created() {
		this.brandIdentify = this.$route.params.brand;
		this.getList();
		console.log(this.brandIdentify)
	},
	methods: {
		getList() {
			this.listQuery.brandIdentify = this.brandIdentify;
			this.$api.apiPostProjectChannelPageList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = [];
				for(const item of response.data) {
					this.$set(item, 'status', item.channelStatus == '1' ? 'disable' : 'enable');
					this.list.push(item);
				}
				this.total = parseInt(response.total);
			});
		},
		handleCreate() {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'create';
		},
		handleUpdate(row) {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'update';
			this.channelForm = Object.assign(this.channelForm, JSON.parse(JSON.stringify(row)));
		},
		handleDelete(row) {
			const self = this;
			self.$confirm('一旦删除，该渠道将永久消失。', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'error',
			}).then(() => {
				self.$api.apiPostProjectChannelDelete(row.channelId).then(response => {
					if(response.errcode != 0) return;
					self.$message({
						message: "删除成功",
						type: "success"
					});
					self.getList();
				});
			}).catch(() => {
				self.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		create() {
			this.$refs["channelForm"].validate(valid => {
                if (valid) {
                    this.loading = true;
					this.channelForm.brandIdentify = this.brandIdentify;
                    this.$api.apiPostProjectChannelAdd(this.channelForm).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						};
                        this.$notify({
                            title: "新增成功",
                            offset: 70,
                            type: "success"
                        });
                        this.dialog_visible_touch_in = false;
						this.loading = false;
                        this.getList();
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		update() {
			this.$refs["channelForm"].validate(valid => {
                if (valid) {
					this.loading = true;
                    this.$api.apiPostProjectChannelEdit({
						brandIdentify: this.brandIdentify,
						channelId: this.channelForm.channelId,
						channelIdentify: this.channelForm.channelIdentify,
						channelName: this.channelForm.channelName,
					}).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						};
						this.$notify({
							title: "修改成功",
							offset: 70,
							type: "success"
						});
						this.dialog_visible_touch_in = false;
						this.loading = false;
						this.getList();
                    }).catch(error => {
                        this.loading = false;
                    });
                }
            });
		},
		switchStatus(row, index) {
			this.$api.apiPostProjectChannelEdit({
				brandIdentify: this.brandIdentify,
				channelId: row.channelId,
				channelIdentify: row.channelIdentify,
				channelName: row.channelName,
				channelStatus: row.status === 'enable' ? 0 : 1
			}).then(response => {
				if(response.errcode != 0) {
					console.log(row.status)
					this.list[index].status = row.status === 'enable' ? 'disable' : 'enable';
					return;
				};
				this.$notify({
					title: "成功",
					offset: 70,
					type: "success"
				});
				this.getList();
			}).catch(error => {
				this.list[index].status = row.status === 'enable' ? 'disable' : 'enable';
			});
		},
		resetForm() {
			this.channelForm = {
                brandIdentify: '',
				channelIdentify: '',
				channelName: ''
			}
			if (this.$refs["channelForm"]) {
				this.$refs["channelForm"].clearValidate();
			}
		},
		handleBack() {
			this.closeTab(this.$route.path);
			this.$router.go(-1);
		}
	}
};
</script>

<style lang="scss" scoped>
.design {
	width: 100%;
	height: 100%;
	background: #FBFBFC;
	overflow: hidden;
	padding: 5px 10px;

	&__header {
		width: 100%;
		height: 40px;
		line-height: 40px;
		padding: 0 5px;

		& .el-link {
			vertical-align: top;
			color: #303133;
		}

		& .el-divider {
			vertical-align: top;
			margin-top: 13px;
		}

		& > .title {
			font-size: 14px;
			font-weight: bold;
			color: #303133;
			vertical-align: top;
			letter-spacing: .5px;
		}

		& > .group {
			height: 100%;
			float: right;
			
			& .el-button {
				vertical-align: top;
				margin-top: 5px;
			}
		}
	}

	&__container {
		width: 100%;
		height: calc(100% - 40px);
		overflow: hidden;

		& .v-form-box{
			width: 100%;
			height: 100%;
			background: #FBFBFC;
			overflow: hidden;

			&__left {
				width: 244px;
				height: 100%;
				display: inline-block;
				vertical-align: top;
				border: solid 1px #E9E9E9;
				border-top-right-radius: 4px;
				overflow: hidden;
				padding: 0;
			}

			&__middle {
				height: 100%;
				display: inline-block;
				vertical-align: top;
				overflow: hidden;
				border: solid 1px #E9E9E9;
				border-top-right-radius: 4px;
				border-top-left-radius: 4px;
				overflow: hidden;
				margin: 0 8px;
				padding: 0;
			}

			&__right {
				display: inline-block;
				vertical-align: top;
				width: 310px;
				height: 100%;
				border: solid 1px #E9E9E9;
				border-top-left-radius: 4px;
				overflow: hidden;
				padding: 0;
			}
		}
	}
}

</style>
